import React, { useEffect, useMemo } from 'react'
import { View } from 'react-native'
import useSdkModuleStorage from '../useSdkModuleStorage'
import Button from '@ui/buttons/Button'
import { z } from 'zod'
import { ResultEventPayload, SdkButtons } from '../BrillenSdk.types'
// import { emitter } from '@modules/brillen-sdk/emitter'
import BrillenSdkModule from '../BrillenSdkModule'

import ModalBottom from '@ui/components/Modal/variants/ModalBottom'
import { useTranslation } from 'react-i18next'
import { FormProvider, useForm } from 'react-hook-form'
import FormInput from '@ui/forms/Input/FormInput'
import { zodResolver } from '@hookform/resolvers/zod'
import { capitalize, refineCommaInput } from '@ca/common'
import { getPdResult, getShResult } from '@ca/common/types'

export const buttonResult = {
  save: SdkButtons.save,
  close: SdkButtons.close,
}

export const BrillenSdkPlaceholderUi = () => {
  const { t } = useTranslation(['modals', 'ui', 'common'])

  const isOpen = useSdkModuleStorage((state) => state.isOpen)
  const type = useSdkModuleStorage((state) => state.type)

  const close = useSdkModuleStorage((state) => state.close)

  const schema = useMemo(() => {
    // Since we build this here we can have nice validation with dynamic values
    const input = z.coerce
      .number()

      .step(
        0.01,
        t('validation:number.step', {
          value: 0.01,
        })
      )

    return z.object({
      left: input,
      right: input,
    })
  }, [t])

  const form = useForm({
    resolver: zodResolver(schema),
  })
  const onClose = () => {
    close()
    form.reset({
      left: '',
      right: '',
    })
  }

  const handleClose = () => {
    BrillenSdkModule.emit('onResult', {
      faceData: JSON.stringify({}),
      button: buttonResult.close,
    } satisfies ResultEventPayload)
    onClose()
  }

  const handleSave = form.handleSubmit((v) => {
    const parsed = {
      left: Number(v.left),
      right: Number(v.right),
    }
    const data =
      type === 'sh'
        ? getShResult(parsed.left, parsed.right)
        : getPdResult(parsed.left, parsed.right)
    const payload = {
      faceData: JSON.stringify(data),
      raw: parsed,
      button: buttonResult.save,
    } satisfies ResultEventPayload
    BrillenSdkModule.emit('onResult', payload)
    console.log('onResult', payload)
    onClose()
  })

  return (
    <ModalBottom
      open={isOpen}
      title={t(`modals:${type || 'pd'}.title`)}
      desc={t(`modals:${type || 'pd'}.desc`)}
      body={
        <>
          <FormProvider {...form}>
            <View className="flex w-full flex-row gap-8 px-16">
              <View className="flex-1">
                <FormInput
                  labelWidth={70}
                  control={form.control}
                  name="right"
                  inputMode="decimal"
                  refine={refineCommaInput}
                  autoCorrect={false}
                  autoCapitalize="none"
                  label={capitalize(t('common:right'))}
                />
              </View>
              <View className="flex-1">
                <FormInput
                  labelWidth={70}
                  control={form.control}
                  name="left"
                  inputMode="decimal"
                  refine={refineCommaInput}
                  autoCorrect={false}
                  autoCapitalize="none"
                  label={capitalize(t('common:left'))}
                />
              </View>
            </View>
          </FormProvider>
        </>
      }
      buttons={
        <>
          <Button
            variant="outlined"
            label={t('ui:save')}
            onPress={handleSave}
          />
          {/* <Button
            variant="outlined"
            label={t('ui:close')}
            onPress={handleClose}
          /> */}
        </>
      }
      close={handleClose}
    ></ModalBottom>
  )
}
